<template>
  <div>
    <el-form ref="form" :model="form" class="form_flex">
      <el-row>
        <!-- 1 -->
        <el-col :span="8">
          <el-form-item
            label="租购意向"
            :label-width="formLabelWidth"
            prop="isSale"
          >
            <el-select
              class="search-select1"
              v-model="isSale"
              placeholder="请选择租购意向"
              @change="handleSlectIntention"
            >
              <el-option
                v-for="(item, index) in intentionList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="推荐人"
            :label-width="formLabelWidth"
            prop="userId"
          >
            <el-select
              class="select"
              v-model="form.userId"
              filterable
              remote
              placeholder="请输入推荐人"
              :remote-method="searchUser"
              @change="checkItem"
              clearable
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="客户名"
            prop="customerName"
          >
            <el-input
              class="search-input"
              v-model="form.customerName"
              placeholder="请输入客户名"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="客户电话"
            prop="phoneNumber"
          >
            <el-input
              class="search-input"
              v-model="form.phoneNumber"
              placeholder="请输入客户电话"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="指定接待销售员"
            prop="factSalesPersonName"
          >
            <el-input
              class="search-input"
              v-model="form.factSalesPersonName"
              placeholder="请输入指定接待销售员"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 1 -->
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="现场接待销售员"
            prop="salesPersonName"
          >
            <el-input
              class="search-input"
              v-model="form.salesPersonName"
              placeholder="请输入现场接待销售员"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <template v-if="isExpend">
          <el-col :span="8">
            <el-form-item
              :label-width="formLabelWidth"
              label="客服"
              prop="customerServiceName"
            >
              <el-input
                class="search-input"
                v-model="form.customerServiceName"
                placeholder="请输入客服"
                @blur="onBlur"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="客户状态"
              :label-width="formLabelWidth"
              prop="status"
            >
              <el-select
                class="search-select1"
                v-model="form.status"
                placeholder="请选择状态"
              >
                <el-option
                  v-for="(item, index) in statusList"
                  :key="index"
                  :label="item"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 1 -->
          <el-col :span="8">
            <el-form-item
              :label-width="formLabelWidth"
              label="报备时间"
              prop="appointmentTime"
            >
              <el-date-picker
                v-model="appointmentTime"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 1 -->
          <el-col :span="8">
            <el-form-item
              :label-width="formLabelWidth"
              label="看房有效期"
              prop="availableTime"
            >
              <el-date-picker
                v-model="availableTime"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label-width="formLabelWidth"
              label="实际到访时间"
              prop="arriveTime"
            >
              <el-date-picker
                v-model="arriveTime"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="8">
          <el-form-item prop="status">
            <el-form-item
              label="楼盘名"
              :label-width="formLabelWidth"
              prop="salesmanName"
            >
              <el-select
                class="select"
                v-model="form.salesmanName"
                filterable
                remote
                placeholder="请输入楼盘名"
                :remote-method="searchUser"
                @change="checkItem"
                clearable
                :loading="loading"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="handleUserDecrypt(item.label)"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </el-col> -->

          <el-col :span="8">
            <el-form-item
              label="修改人"
              :label-width="formLabelWidth"
              prop="updateUserId"
            >
              <el-select
                class="select"
                v-model="form.updateUserId"
                filterable
                remote
                placeholder="请输入修改人"
                :remote-method="searchUpadater"
                @change="checkUpdaterItem"
                clearable
                :loading="loading"
              >
                <el-option
                  v-for="item in updaterOptions"
                  :key="item.value"
                  :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :label-width="formLabelWidth"
              label="修改时间"
              prop="updateTime"
            >
              <el-date-picker
                v-model="updateTime"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </template>
        <el-col :span="8">
          <el-form-item class="btn">
            <el-button @click="onSearch" icon="el-icon-search" size="small"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-plus"
              @click="resetForm('form')"
              >清空</el-button
            >
            <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
              >刷新</el-button
            >
            <!-- 导出 -->
            <PermissionsBtn
              :icon="'el-icon-download'"
              :btnType="'primary'"
              :permissionName="'_Export'"
              :downloadUrl="'/userAdmin/Introduce/downLoad'"
              :checkList="checkList"
              :form="exportForm"
            ></PermissionsBtn>
            <el-button
              size="small"
              type="success"
              @click="isExpend = !isExpend"
              >{{ !isExpend ? '展开' : '收起' }}</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserModelApi } from '@/api/user.js';
import { decrypt, encrypt } from '@/utils/encryp';
export default {
  name: 'UserSearchBar',

  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      intentionList: [
        {
          label: '租赁',
          value: 0,
        },
        {
          label: '购买',
          value: 1,
        },
      ],
      // 表单内容
      form: {
        isSale: '', // 租购意向
        status: '',
        userId: '', // 推荐人/
        updateUserId: '', // 修改人
        customerName: '', // 客户名称
        salesPersonName: '', // 接待销售
        factSalesPersonName: '', // 现场接待销售员
        customerServiceName: '', //  客服名称
        appointmentStartTime: '', // 报备时间
        appointmentEndTime: '',
        availableStartTime: '', // 看房有效期
        availableEndTime: '',
        updateStartTime: '', // 修改时间
        updateEndTime: '',
        arriveStartTime: '',
        arriveEndTime: '',
      },
      exportForm: {},
      isSale: '',
      userName: '',
      dateTime: [],
      updateTime: [], // 修改时间
      options: [],
      updaterOptions: [],
      loading: false,
      path: '',
      appointmentTime: '',
      availableTime: '',
      arriveTime: '',
      isExpend: false,
      areaId: '',
    };
  },
  computed: {
    ...mapGetters(['statusList', 'pickerOptions', 'roleList']),
  },
  watch: {
    // 将标准时间转换成 yyyy-mm-dd
    // dateTime: function (val) {
    //   let timeList = val.map((item) => {
    //     return this.$moment(item).format('YYYY-MM-DD HH:mm:ss');
    //   });
    //   this.form.appointmentStartTime = timeList[0];
    //   this.form.appointmentEndTime = timeList[1];
    //   return;
    // },
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
    this.areaId = localStorage.getItem('areaId')
      ? JSON.parse(localStorage.getItem('areaId')).areaId
      : '';
  },
  methods: {
    // 租购下拉选择
    handleSlectIntention(val) {
      this.form.isSale = val > 0;
      // console.log(this.form.isSale);
      // console.log(val);
    },
    // 失去焦点
    onBlur() {
      let {
        customerName,
        factSalesPersonName,
        phoneNumber,
        salesPersonName,
        customerServiceName,
      } = this.form;
      this.exportForm = {
        ...this.form,
        customerName: customerName ? encrypt(customerName) : '',
        factSalesPersonName: factSalesPersonName
          ? encrypt(factSalesPersonName)
          : '',
        phoneNumber: phoneNumber ? encrypt(phoneNumber) : '',
        salesPersonName: salesPersonName ? encrypt(salesPersonName) : '',
        customerServiceName: customerServiceName
          ? encrypt(customerServiceName)
          : '',
      };

      // console.log('加密后：', this.exportForm);
    },
    // 搜索用户
    async searchUser(val) {
      this.loading = true;
      let res = await getUserModelApi({ userName: val, areaId: this.areaId });
      this.loading = false;
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 搜索修改人
    async searchUpadater(val) {
      this.loading = true;
      let res = await getUserModelApi({ userName: val, areaId: this.areaId });
      this.loading = false;
      this.updaterOptions = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },

    // 选择下拉选项
    checkItem(val) {
      this.form.userId = val;
    },

    // 修改人下拉选项
    checkUpdaterItem(val) {
      this.form.updateUserId = val;
    },

    // 搜索，触发父组件请求数据的方法
    onSearch() {
      // 0 = 全部， 没有0这个状态，重置为0
      if (this.form.status === 0) {
        this.form.status = '';
      }
      // 租售
      // this.form['isSale'] = this.isSale ? Boolean(this.isSale) : '';
      // 报备时间
      this.form['appointmentStartTime'] = this.appointmentTime
        ? this.appointmentTime[0]
        : '';
      this.form['appointmentEndTime'] = this.appointmentTime
        ? this.appointmentTime[1]
        : '';
      // 修改时间
      this.form['updateStartTime'] = this.updateTime ? this.updateTime[0] : '';
      this.form['updateEndTime'] = this.updateTime ? this.updateTime[1] : '';
      // 看房有效期
      this.form['availableStartTime'] = this.availableTime
        ? this.availableTime[0]
        : '';
      this.form['availableEndTime'] = this.availableTime
        ? this.availableTime[1]
        : '';
      // 到访时间
      this.form['arriveStartTime'] = this.arriveTime ? this.arriveTime[0] : '';
      this.form['arriveEndTime'] = this.arriveTime ? this.arriveTime[1] : '';

      // IsSale; //租售意向(布尔值)
      // FactSalesPersonName; //现场接待销售员(人名,不传Id)

      // AppointmentStartTime; //报备开始时间
      // AppointmentEndTime; //报备结束时间

      // AvailableStartTime; //看房有效期开始时间
      // AvailableEndTime; //看房有效期结束时间

      // ArriveStartTime; //到访开始时间
      // ArriveEndTime; //到访结束时间
      // 客户电话
      let { phoneNumber, salesPersonName, factSalesPersonName } = this.form;
      this.$emit('search', {
        ...this.form,
        ...{
          salesPersonName: salesPersonName ? encrypt(salesPersonName) : '',
          factSalesPersonName: factSalesPersonName
            ? encrypt(factSalesPersonName)
            : '',
          phoneNumber: phoneNumber ? encrypt(phoneNumber) : '',
        },
      });
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm(formName) {
      this.form.isSale = '';
      this.isSale = '';
      this.appointmentTime = [];
      this.availableTime = [];
      this.dateTime = [];
      this.userName = '';
      this.updateTime = [];
      this.availableTime = [];
      this.arriveTime = [];
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 260px;
}

.search-select1 {
  // width: 120px;
}

.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
